import { KM_UNIT } from "../types/building";

export const getDistanceFormat = (distance: number) => {
  if (distance < KM_UNIT) {
    return `${distance.toFixed(0)}m`;
  } else {
    if (distance / KM_UNIT < 1000) {
      return `${(distance / KM_UNIT).toFixed(2)}km`;
    } else {
      return `${(distance / KM_UNIT).toFixed(0)}km`;
    }
  }
};
